import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { GOOGLE_MAPS_API } from '../googleMapsAPIClient';
import { GoogleReverseGeocodeResponse } from '../types';

/**
 * React Query hook to reverse geocode coordinates (lat/lng) to get address information.
 * This hook uses `useMutation` to dynamically fetch address from coordinates.
 */
export const useGoogleMapsReverseGeocodeQuery = () => {
  const { mutate, isError, isPending, error } = useMutation<
    GoogleReverseGeocodeResponse,
    IApiError,
    { lat: number; lng: number; language: 'en' }
  >({
    mutationFn: ({ lat, lng, language }) =>
      GOOGLE_MAPS_API.reverseGeocode(lat, lng, language),
    mutationKey: ['googleMapsReverseGeocode'],
    retry: 1,
    onError: (err) => err,
  });

  return {
    mutate,
    isError,
    isPending,
    error,
  };
};
